import * as React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Formik, FormikProps } from 'formik';
import { VoucherApi } from 'common/api/resources/Voucher';
import { Member } from 'common/api/models/Member';
import { FormInput } from '../form/FormInput';

export interface BadgeBackageFullFillDropDownDialog {}
interface BadgeBackageFullFillDropDownDialogProps {
  title?: string;
  isOpen: boolean;
  voucher: string;
  member?: Member;
  onSave: () => void;
  onCancel: () => void;
  badgePackageFullfilled?: string;
  error?: string;
}
export interface BadgeBackageFullFillDropDownDialogState {
  error?: string;
}
class FormValues {
  badgePackageFullfilled: string;
}

export class BadgeBackageFullFillDropDownDialog extends React.Component<
  BadgeBackageFullFillDropDownDialogProps,
  BadgeBackageFullFillDropDownDialogState
> {
  state: BadgeBackageFullFillDropDownDialogState = {
    error: '',
  };

  initialValues() {
    return {
      badgePackageFullfilled: this.props.badgePackageFullfilled ? 'YES' : 'NO',
    };
  }

  handleSubmit = async (values: FormValues) => {
    if (this.props.voucher) {
      const updateBadgePackageFullfilled = values.badgePackageFullfilled === 'YES' ? true : false;

      let updateParams = {};
      updateParams = {
        badgePackageFullfilled: updateBadgePackageFullfilled,
      };

      // console.log(updateParams);
      VoucherApi.updateVoucher(this.props.voucher, updateParams)
        .then(() => {
          this.props.onSave();
        })
        .catch(e => {
          this.setState({ error: e.response.data.message });
        });
    }
  };

  render() {
    return (
      <Modal size="md" isOpen={this.props.isOpen} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<FormValues>) => (
            <form onSubmit={form.handleSubmit}>
              <ModalHeader toggle={this.props.onCancel}>{this.props.title ? this.props.title : ''}</ModalHeader>
              <ModalBody>
                <FormInput
                  id="badgePackageFullfilled"
                  name="badgePackageFullfilled"
                  label="Badge Package Fullfilled?"
                  tag="select"
                  autoComplete="off"
                >
                  <option value="NO">No</option>
                  <option value="YES">Yes</option>
                </FormInput>
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit">
                    Save
                  </Button>
                </div>
              </ModalFooter>

              {this.state!.error && <div className="alert alert-danger">{this.state!.error}</div>}
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dialogs/BadgePackageFullFillDialog.tsx